import React, { useContext, useEffect, useState } from 'react'
import Filters from './Filters';
import axios from 'axios';

import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';
import Card from './Card';
import useApi from '../../../hooks/useApi';
import { BasePopupContext } from '../../../hooks/usePopup';
import { DESENDING_ORDER, LISTING_LIMIT, ORDER_DESCENDING } from '../../../constants';
import { customStringify } from '../../../utils';
import { network_tl } from '../../../translations';
import RetryApi from '../../RetryApi';
import Loading from '../../Loading';
import Pagination from '../../Pagination';

const InfluencerPopup = () => {
    const [filters, setFilters] = useState({
        search: "",
        city: "",
        category: "",
        followers: "",
        engagement_rate: "",
        cost: "",
        sort_order: ORDER_DESCENDING
    })

    const [appliedFilters, setAppliedFilters] = useState({
        search: "",
        city: "",
        category: "",
        followers: "",
        engagement_rate: "",
        cost: "",
        sort_order: ORDER_DESCENDING
    })

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false);
    const [count, setCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [sort, setSort] = useState({ title: "created_on", order: DESENDING_ORDER });
    let offset = 0;



    const intl = useIntl();
    const { Axios } = useApi();

    const getData = async (curr) => {
        try {
            setLoading(true);
            setError(false);
            if (curr) {
                offset = 0;
            }
            else if (count) {
                offset = currentPage * LISTING_LIMIT - LISTING_LIMIT;
            } else {
                offset = 0;
            }
            const result = await Axios.get(`api/user/listing-agency-influencer?limit=${LISTING_LIMIT}&offset=${offset}&search=${appliedFilters.search.trim()}`);
            setData(result.data.payload);
            setLoading(false);
            setCount(result.data.count)
        } catch (e) {
            if (axios.isCancel(e)) {

            } else if (e.response) {
                setError(customStringify(e.response.data.description))
                setLoading(false)
            } else {
                setError(network_tl(intl))
                setLoading(false)
            }
        }
    }

    useEffect(() => {
        getData()
    }, [currentPage, sort])

    useEffect(() => {
        getData(1)
    }, [appliedFilters])



    const applyFilters = () => {
        const copy = _.cloneDeep(filters)
        setCurrentPage(1);
        setAppliedFilters(copy)
    }

    const resetFilters = () => {
        setCurrentPage(1)
        setFilters({
            search: "",
            city: "",
            category: "",
            followers: "",
            engagement_rate: "",
            cost: "",
            sort_order: ORDER_DESCENDING
        })
        setAppliedFilters({
            search: "",
            city: "",
            category: "",
            followers: "",
            engagement_rate: "",
            cost: "",
            sort_order: ORDER_DESCENDING
        })
    }

    const refreshListing = () => {
        setCurrentPage(1);
        getData(1)
    }

    return (
        <div className=' '>
            <Filters
                filters={filters}
                setFilters={setFilters}
                applyFilters={applyFilters}
                resetFilters={resetFilters}
                appliedFilters={appliedFilters}
            />


            <div className='mt-12 py-5'>


                {
                    loading && !error ?
                        <Loading />
                        : !loading && error ?
                            <RetryApi error={error} retry={getData} />

                            : !loading && !error ?
                                <div className=' pb-10'>
                                    {
                                        data.length > 0 ?
                                            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4  gap-5 justify-items-center'>
                                                {data.map((item, index) => (
                                                    <Card
                                                        key={index}
                                                        index={index}
                                                        data={item}
                                                    />
                                                ))}
                                            </div>
                                            : <p className='text-t-light flex justify-center w-full'><FormattedMessage id="no_data_found" defaultMessage={"No Data Found"} /></p>

                                    }
                                    <div className="flex my-10 justify-end">
                                        <Pagination
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            perPage={LISTING_LIMIT}
                                            offset={offset}
                                            total_pages={Math.ceil(count / LISTING_LIMIT)}
                                            count={count} />
                                    </div>

                                </div>
                                :
                                null
                }


            </div>
        </div>
    )
}

export default InfluencerPopup